import http from '@/core/http';
import { DOMAIN_SYSTEM_ENUM } from '@toy/utils';
import {
  IUserInfoParams,
  IUserInfoItem,
  IAddUserInfoParams,
  IUserInfoLogs,
} from './index.d';
/**
 * @see https://yapi.baibu.la/project/996/interface/api/73198
 *
 * @请求方法: POST
 * @更新时间: 2021-04-2dd5 16:52:32
 */
export const getUserInfoPage = (params: IUserInfoParams) => {
  return http.post<IUserInfoItem[]>({
    url: '/manage-app/web/v1/user-info/page',
    data: params,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};
// 启用/停用
export const UpdateEnableUserInfo = (params: {
  id: string;
  isEnabled: string;
  remark?: string;
}) => {
  return http.put({
    url: '/manage-app/web/v1/user-info/updateEnable',
    data: params,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};
// 删除
export const DelUserInfoApi = (id: string) => {
  return http.put({
    url: `/manage-app/web/v1/user-info/${id}`,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};
// 添加
export const AddUserInfo = (params: IAddUserInfoParams) => {
  return http.post({
    url: '/manage-app/web/v1/user-info',
    data: params,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};
// 编辑
export const EditUserInfo = (params: IAddUserInfoParams) => {
  return http.put({
    url: '/manage-app/web/v1/user-info',
    data: params,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};
// 操作记录
export const UserInfoLogs = (id: string) => {
  return http.get<IUserInfoLogs[]>({
    url: `/manage-app/web/v1/user-Log/${id}`,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};

/**
 * 刷新用户状态
 * @see https://yapi.ibaibu.com/project/996/interface/api/175369
 */
export const UserInfoRefreshWorkState = (companyId: string) => {
  return http.put({
    url: `/manage-app/web/v1/user-info/refresh-work-state/${companyId}`,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};
